import React from 'react';
import Parser from 'html-react-parser';
import { Container, TipCardDesktop, TipCardMobile } from './styles';
import TipIcon from '../../../assets/icons/tip.svg';
import Section from '../commons/AccordionSection';

const Tips = ({ device, tips }) => {
  return (
    <>
      {tips?.length > 0 ? (
        <Container device={device}>
          {device === 'desktop' &&
            tips?.map((tip, index) => (
              <TipCardDesktop data-publi={`Tip-${index}`} key={tip}>
                <img src={TipIcon} alt='tip icon' />
                {Parser(tip)}
              </TipCardDesktop>
            ))}

          {device !== 'desktop' && (
            <Section
              data-publi={`Tip-`}
              title='Consejos'
              iconTitle={TipIcon}
              fontSize='12px'
              fontWeight='600'
              lineHeight='16px'
              withoutBorder
            >
              <TipCardMobile>
                {tips?.map((tip, index) => (
                  <React.Fragment key={`Tip-${index}`}>
                    <div className='text' data-publi={`Tip-${index}`}>
                      {Parser(tip)}
                    </div>
                  </React.Fragment>
                ))}
              </TipCardMobile>
            </Section>
          )}
        </Container>
      ) : null}
    </>
  );
};

export default Tips;
